import get from 'lodash/get';
import unset from 'lodash/unset';

export class Clock {
  constructor() {
    this.timers = {};
  }

  set(values) {
    Object.assign(this, values);
  }

  start(id, tick, wait) {
    this.stop(id);
    this.timers[id] = setInterval(() => tick({ id, clock: this }), wait);
    return this.timers[id];
  }

  stop(id) {
    clearInterval(get(this, `timers.${id}`));
    unset(this, `timers.${id}`);
  }

  startAppResetTime(every) {
    this.start(
      'dispatch-reset-time',
      () => this.store.dispatch({ type: 'RESET_TIME' }),
      every
    );
  }
}

let instance = new Clock();
export default instance;
